<template>
  <div>
    <div class="mb-20" id="optin-settings">
      <div class="text-2xl font-bold">
        {{ $t('frontend_groovemail_forms_step2_option_setting') }}
      </div>
      <div class="text-sm mt-2 mb-4 text-grey-700">
        {{ $t('frontend_groovemail_forms_step2_configure') }}
      </div>

      <div
        v-for="(option, index) in optin_radio_options"
        :key="index"
        class="form-content-box p-10 mb-4"
        @click="setoptinvalue(option)"
      >
        <gd-custom-radio
          v-model="localModel.optin"
          class="form-setup-radio"
          :option="option"
          value="localModel.optin"
          @onUpdateOption="confirmationOptinUpdated()"
        ></gd-custom-radio>
      </div>
      <div
        class="bg-white p-10 pt-0"
        style="margin-top: -40px"
        v-if="this.localModel.optin === 'double'"
      >
        <div v-if="this.localModel.optin === 'double'" class="mb-4">
          <div
            class="custom-radio-list"
            v-for="(option, index) in confirm_options"
            :key="index"
          >
            <gd-custom-radio
              v-model="localModel.confirmlink_sendoption"
              :option="option"
              value="localModel.confirmlink_sendoption"
              @onUpdateOption="confirmationSendOptionUpdated()"
            ></gd-custom-radio>
          </div>

          <div class="w-full">
            <div class="mb-6" style="width: 400px">
              <div v-if="localModel.confirmlink_sendoption === 'email'">
                <div class="text-base font-semibold mb-2">
                  {{ $t('frontend_groovemail_forms_step2_sender') }}
                </div>
                <gd-dropdown
                  size="full"
                  variant="base"
                  :placeholder="$t('frontend_groovemail_sequences_email_select_sender')"
                  v-model="localModel.confirmlink_sender_id"
                  :options="confirmationEmailSenderList"
                  @input="updateConfirmationEmailSender"
                />

                <div
                  class="text-sm text-danger"
                  v-if="
                    this.isEmailContentSubmitted &&
                    this.localModel.optin === 'double' &&
                    (!this.localModel.confirmlink_sender_id ||
                      this.localModel.confirmlink_sender_id === '-1')
                  "
                >
                  {{ $t('frontend_groovemail_campaigns_create_select_sender_to_proceed') }}
                </div>

                <div
                  class="flex justify-end text-primary text-sm font-semibold cursor-pointer"
                  @click="openCreateEmailSenderModal()"
                >
                  <PlusIcon class="h-5 w-5"/>
                  <p> {{ $t('frontend_groovemail_settings_integeration_add_new_integeration') }}</p>
                </div>
              </div>
              <div v-if="localModel.confirmlink_sendoption === 'sms'">
                <div class="text-base font-semibold mb-2">
                  {{ $t('frontend_groovemail_campaigns_sms_sender_label') }}
                </div>
                <gd-dropdown
                  size="full"
                  variant="base"
                  :placeholder="$t('frontend_groovemail_sequences_email_select_sender')"
                  v-model="localModel.confirmlink_sender_id"
                  :options="confirmationSmsSenderList"
                  @input="updateConfirmationSmsSender"
                />

                <div
                  class="text-sm text-danger"
                  v-if="
                    this.isSmsContentSubmitted &&
                    this.localModel.optin === 'double' &&
                    (!this.localModel.confirmlink_sender_id ||
                      this.localModel.confirmlink_sender_id === '-1')
                  "
                >
                  {{ $t('frontend_groovemail_campaigns_create_select_sender_to_proceed') }}
                </div>

                <div
                  class="flex justify-end text-primary text-sm font-semibold cursor-pointer"
                  @click="openCreateSmsSenderModal()"
                >
                  <PlusIcon class="h-5 w-5"/>
                  <p>{{ $t('frontend_groovemail_settings_integeration_add_new_integeration') }}</p>
                </div>
              </div>
            </div>
            <div class="mb-6">
              <div
                v-if="
                  this.localModel.optin === 'double' &&
                  localModel.confirmlink_sendoption === 'email'
                "
              >
                <div style="width: 400px">
                  <div class="mb-6">
                    <div class="font-semibold text-base mb-2 flex items-center">
                      <span class="pr-1">{{
                        $t('frontend_groovemail_forms_step2_subject')
                      }}</span>
                      <button
                        v-tooltip="{
                          content: $t(
                            'frontend_add_dynamic_variables_to_subject'
                          ),
                          placement: 'right-start',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          offset: 10,
                          delay: {
                            show: 200,
                            hide: 300,
                          },
                        }"
                      >
                        <InfoIcon class="text-grey-600 h-4 w-4"/>
                      </button>
                    </div>
                    <div class="relative">
                      <text-input
                        variant="base"
                        v-model="localModel.confirmlink_subject"
                        :placeholder="$t('frontend_groovemail_forms_form_enter_confirm_subject')"
                        :validator="$v.localModel.confirmlink_subject"
                      />
                      <div
                        v-click-outside="closeSubjectVariables"
                        class="plus-round-icon bg-primary absolute"
                        style="right: 8px; top: 8px"
                        @click="openSubjectVariables"
                      >
                        <div
                          class="bg-white btn-radius py-6 pl-6 absolute z-10 overflow-auto"
                          style="
                            width: 290px;
                            right: 0;
                            top: 39px;
                            box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
                          "
                          v-if="showSubjectDropdown"
                        >
                          <div class="pr-6">
                            <text-input
                              variant="base"
                              v-model="emailSubjectVariableSearch"
                              @input="searchQueryChangedSmsVariable"
                              :placeholder="$t('frontend_groovemail_tables_search_query')"
                            >
                              <SearchIcon slot="prependIcon"/>
                            </text-input>
                          </div>
                          <VuePerfectScrollbar>
                            <div
                              class="mt-6 text-sm font-semibold"
                              style="max-height: 300px"
                            >
                              <div
                                class="mb-6"
                                v-for="(
                                  option, index
                                ) in dynamic_variables_sms_content_subject"
                                :key="index"
                              >
                                <div
                                  class="cursor-pointer text-grey-700 text-left"
                                  @click="copyVariableInSubject(option)"
                                >
                                  {{ option.label }}
                                </div>
                              </div>
                            </div>
                          </VuePerfectScrollbar>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-6">
                    <div class="font-semibold text-base mb-2">
                      {{ $t('frontend_groovemail_forms_step2_preview') }}
                    </div>
                    <text-input
                      variant="base"
                      v-model="localModel.confirmlink_previewtext"
                      :placeholder="$t('frontend_groovemail_campaigns_enter_preview')"
                    />
                  </div>
                </div>
                
                <div class="flex flex-col my-6">
                  <label class="font-semibold text-base mb-2">
                    {{ $t('frontend_groovemail_email_types_label') }}
                  </label>
                  <div class="flex">
                    <div
                      v-for="(option, index) in email_type_options"
                      :key="index"
                      class="w-1/3 campaign-radio"
                      :class="{ 'pl-2': index !== 0, 'pr-2': index !== email_type_options.length - 1 }"
                    >
                      <gd-custom-radio
                        v-model="localModel.confirm_editor_type"
                        class="bg-white border p-8 pb-2 text-center"
                        :option="option"
                        value="localModel.confirm_editor_type"
                      ></gd-custom-radio>
                    </div>
                  </div>
                </div>

                <div class="w-full">
                  <div v-if="localModel.confirm_editor_type === 3 && showEmailComposers">
                    <div class="mb-2">
                      <label class="font-semibold text-base">
                        {{ $t('frontend_groovemail_campain_message') }}
                      </label>
                    </div>
                    <div class="mb-2" style="width: 400px" v-if="this.localModel.confirm_template_name">
                      <label class="font-semibold text-base">
                        {{ $t('frontend_groovemail_email_builder_past_template_email_name') }} : {{ this.localModel.confirm_template_name }}
                      </label>
                    </div>
                    <div class="flex justify-between" style="width: 400px">
                      <gd-button
                        size="expand"
                        variant="primary"
                        @click="openEmailBuilder"
                        >{{
                          this.localModel.confirm_email_id
                          ? $t('frontend_groovemail_email_builder_edit_your_email_placeholder')
                          : $t('frontend_groovemail_email_builder_compose_your_email')
                        }}</gd-button
                      >
                      <gd-button
                        size="md"
                        class="ml-4"
                        :class="{
                          'cursor-not-allowed disabled-preview': !localModel.confirmlink_content,
                        }"
                        @click="
                          localModel.confirmlink_content
                            ? openConfirmPreview()
                            : null
                        "
                      >
                        <PreviewIcon class="h-5 w-5"/>
                      </gd-button>
                    </div>
                  </div>
                  <div v-if="localModel.confirm_editor_type !== 3 && showEmailComposers">
                    <email-basic-editor
                      :key="1"
                      ref="optin-form-email-editor"
                      :editorOptions="optinFormEditorOptions"
                      :editorContent="localModel.confirmlink_content"
                      :editorNodeWithNoMargin="true"
                      :editorWithBlockedLinkRestriction="true"
                      :editorDynamicVariables="builderVariables"
                      openedFrom="optin-forms"
                      :allowEditorPreview="true"
                      :allowEditorHtmlView="false"
                      :currentEditorView="localModel.confirm_editor_type"
                      @editorContentUpdated="localModel.confirmlink_content = $event"
                      @templateSelected="localModel.confirmlink_subject = $event.subject; localModel.confirmlink_previewtext = $event.previewText"
                    ></email-basic-editor>
                  </div>

                  <div
                    v-if="checkValidEmailContent()"
                    class="text-sm text-danger"
                  >
                    {{ $t('frontend_groovemail_forms_step2_please_include') }}
                    '{optin_confirmation_link}'
                    {{ $t('frontend_groovemail_forms_step2_inside') }}
                  </div>
                </div>
                <div class="mt-4">
                  <SendTestEmail
                    ref="sendConfirmationTestMail"
                    @showLoader="showLoader"
                    @hideLoader="hideLoader"
                    @proceeedSendingTestEmail="proceeedSendingTestEmail"
                  ></SendTestEmail>
                </div>
              </div>
              <div
                v-if="
                  this.localModel.optin === 'double' &&
                  localModel.confirmlink_sendoption === 'sms'
                "
                class="flex flex-col mb-4"
              >
                <div class="flex justify-between mb-2">
                  <div class="font-semibold text-base">
                    {{ $t('frontend_groovemail_campains_step4_send_message') }}
                  </div>
                  <div class="flex relative">
                    <div class="text-sm text-grey-700 mr-2">
                      {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_insert_varaibles') }}
                    </div>
                    <div
                      v-click-outside="closeSmsVariables"
                      class="plus-round-icon bg-primary"
                      @click="openSmsVariables"
                    >
                      <div
                        class="bg-white btn-radius py-6 pl-6 absolute z-10 overflow-auto"
                        style="
                          width: 290px;
                          right: 0;
                          top: 39px;
                          box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
                        "
                        v-if="showSmsVariableDropdown"
                      >
                        <div class="search-variable-input pr-6">
                          <text-input
                            variant="base"
                            v-model="smsVariableSearch"
                            @input="searchQueryChangedSmsVariable"
                            :placeholder="$t('frontend_groovemail_tables_search_query')"
                          >
                            <SearchIcon slot="prependIcon"/>
                          </text-input>
                        </div>
                        <VuePerfectScrollbar>
                          <div
                            class="mt-6 text-sm font-semibold"
                            style="max-height: 300px"
                          >
                            <div
                              class="mb-6"
                              v-for="(
                                option, index
                              ) in dynamic_variables_sms_content_subject"
                              :key="index"
                            >
                              <div
                                class="cursor-pointer text-grey-700 text-left"
                                @click="copySmsvariable(option)"
                              >
                                {{ option.label }}
                              </div>
                            </div>
                          </div>
                        </VuePerfectScrollbar>
                      </div>
                    </div>
                  </div>
                </div>
                <text-area
                  variant="base"
                  id="sms-text-area"
                  v-model="localModel.confirmlink_sms_content"
                  style="height: 260px"
                  :placeholder="$t('frontend_groovemail_campaigns_create_broadcast_enter_sms_content')"
                  :validator="$v.localModel.confirmlink_sms_content"
                />
                <!-- Sms Content Here -->
                <div
                  v-if="
                    ((this.localModel.confirmlink_sms_content &&
                      !this.localModel.confirmlink_sms_content.includes(
                        '{optin_confirmation_link}'
                      )) ||
                      !this.localModel.confirmlink_sms_content) &&
                    isSmsContentSubmitted
                  "
                  class="text-sm text-danger"
                >
                  {{ $t('frontend_groovemail_forms_step2_please_include') }}
                  '{optin_confirmation_link}'
                  {{ $t('frontend_groovemail_forms_step2_inside') }}
                </div>
              </div>
            </div>
            <div>
              <div
                v-if="
                  (localModel.confirmlink_sendoption === 'email' ||
                    localModel.confirmlink_sendoption === 'sms') &&
                  this.localModel.optin === 'double'
                "
              >
                <div class="text-base font-semibold mb-2">
                  {{ $t('frontend_groovemail_forms_step2_confirmation') }}
                </div>
                <div v-if="localModel.confirmlink_page === 'custom'">
                  <div
                    v-if="localModel.confirmlink_destination !== 'Groovepages'"
                    style="width: 360px"
                  >
                    <text-input
                      variant="base"
                      v-model="localModel.confirmlink_pageurl"
                      placeholder="https://www.example.com/opt/confirmation"
                      :validator="$v.localModel.confirmlink_pageurl"
                    />
                  </div>
                  <div v-else class="w-9/12 flex">
                    <div class="w-1/2">
                      <select
                        class="rounded float-left w-11/12 text-sm rounded bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                      >
                        <option value>
                          {{ $t('frontend_groovemail_forms_step2_select_site') }}
                          ...
                        </option>
                        <option value="nosite">
                          {{ $t('frontend_groovemail_forms_step2_nosite') }}
                        </option>
                      </select>
                    </div>
                    <div class="w-1/2">
                      <select
                        v-model="localModel.confirmlink_pageurl"
                        class="rounded float-left w-11/12 text-sm rounded bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                      >
                        <option value>
                          {{ $t('frontend_groovemail_forms_step2_select') }}
                          ...
                        </option>
                        <option
                          v-for="(page, index) in pages"
                          :key="index"
                          :value="page.path"
                        >
                          {{ page.meta.pageTitle }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-20" id="success-message">
      <div class="text-2xl font-bold">
        {{ $t('frontend_groovemail_forms_step2_success') }}
      </div>
      <div class="text-sm mt-2 mb-6 text-grey-700">
        {{ $t('frontend_groovemail_forms_step2_success_message_description') }}
      </div>
      <div class="form-content-box p-10 mb-4">
        <div v-if="localModel.success_destination !== 'Groovepages'">
          <gd-custom-radio
            v-model="localModel.success_option"
            class="form-setup-radio"
            :option="form_success_options[0]"
            value="localModel.success_option"
          ></gd-custom-radio>
          <div v-if="localModel.success_option === 'url'" style="width: 360px">
            <div class="text-sm font-semibold text-grey-700 mt-6 mb-2">
              {{ $t('frontend_groovemail_forms_successpage_url') }}
            </div>
            <text-input
              variant="base"
              v-model="localModel.success_pageurl"
              placeholder="https://www.example.com/opt/confirmation"
              :validator="$v.localModel.success_pageurl"
            />
          </div>
          <div v-else class="w-9/12 flex">
            <div class="w-1/2">
              <select
                class="float-left w-11/12 text-sm rounded bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
              >
                <option value>
                  {{ $t('frontend_groovemail_forms_step2_select_site') }}
                  ...
                </option>
                <option value="nosite">
                  {{ $t('frontend_groovemail_forms_step2_no_site') }}
                </option>
              </select>
            </div>
            <div class="w-1/2">
              <select
                v-model="localModel.success_pageurl"
                class="float-left w-11/12 text-sm rounded bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
              >
                <option value>
                  {{ $t('frontend_groovemail_forms_step2_select') }}
                  ...
                </option>
                <option
                  v-for="(page, index) in pages"
                  :key="index"
                  :value="page.path"
                >
                  {{ page.meta.pageTitle }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Email builder modal -->
    <slide-over
      id="generic-email-builder-modal"
      bgColor="white"
      width="full"
      animation="slideup"
      name="generic-email-builder-modal-confirm"
      @collapse="openConfirmEmailChangeLost('email')"
    >
      <email-builder
        ref="optin-form-email-builder"
        :emailTemplateId="emailTemplateId"
        :templateId="confirm_template_id"
        :emailMeta="getEmailMetaData"
        :openedFrom="'optin-form'"
        :openedType="localModel.confirm_email_id ? 'edit' : 'add'"
        :templateType="templateType"
        :builderVariables="builderVariables"
        :blockedLinkRestriction="true"
        :showResetTemplate="true"
        :allowSaveRows="true"
        @saveEmailTemplateContent="saveContentWithMeta"
        @changeCurrentTemplate="openConfirmEmailChangeLost('template')"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
      ></email-builder>
    </slide-over>


    <!-- Confirmation email change lost modal -->
    <confirm-modal
      :ref="`step2-confirmation-email-change-lost`"
      :name="`step2-confirmation-email-change-lost`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :hideClose="true"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="confirmMessage"
      @confirm="confirmEmailChangeLost"
    />


    <!-- Confirmation editor type change modal -->
    <confirm-modal
      :ref="`step2-confirmation-editor-type`"
      :name="`step2-confirmation-editor-type`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :hideClose="true"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_email_type_change_warning')"
      @confirm="confirmEditorTypeChange"
      @close="closeConfirmEditorTypeChange"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Notify from '@groovepages/gd-ui-kit/notify';
import { required, url } from 'vuelidate/lib/validators';

import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ClickOutside from 'vue-click-outside';
import themeConfig from '@/theme/themeConfig';

import EmailBuilder from '@/components/befree-email-builder/builder.vue';
import EmailBasicEditor from '@/components/EmailBasicEditor.vue';
import { syncEditorContent } from '@/components/emailContentValidation';
import SlideOver from '@/components/SlideOver.vue';
import SendTestEmail from '@/components/send-test-email';
import showAlert from '@/components/sweet-alert-popup.js';

// import icons
import InfoIcon from '@/assets/images/icons/new/info_new.svg';
import PreviewIcon from '@/assets/images/icons/new/preview_new.svg';
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import SearchIcon from '@/assets/images/icons/new/search_new.svg';

export default {
  name: 'Step2',

  components: {
    VuePerfectScrollbar,
    InfoIcon,
    EmailBuilder,
    SlideOver,
    EmailBasicEditor,
    SendTestEmail,
    PreviewIcon,
    PlusIcon,
    SearchIcon,
  },
  
  props: {
    model: {
      required: true,
    },
  },

  directives: {
    ClickOutside,
  },

  data() {
    return {
      editorTypeChangedInternally: false,
      showEmailComposers: true,
      dynamic_variables_sms_content_subject: [],
      smsVariableSearch: '',
      showSmsVariableDropdown: false,
      emailSubjectVariableSearch: '',
      showSubjectDropdown: false,
      isSmsContentSubmitted: false,
      isEmailContentSubmitted: false,
      formConatinsPhone: false,
      verifiedSendersRequired: false,
      senders: [],
      smsSenders: [],
      optinFormEditorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              [{ list: 'ordered' }, { list: 'bullet' }],

              ['link', 'image'],
              [{ size: ['10px', false, '18px', '32px'] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ align: [] }],
            ],
            handlers: {
              image: () => this.handleImageInsertionInContent()
            }
          },
        },
      },
      localModel: this.model,
      pages: [],
      isValid: true,
      selected_optin_value: 'Single opt-in',
      emailTemplateId: '',
      templateType: '',
      confirm_template_id: null,
      newEmailType: null,
      oldEmailType: null,
      confirmMessage: '',
      confirmTarget: '',
    };
  },

  async created() {
    try {
      this.showLoader();
      await this.checkPhonePresent();
      await this.fetchSendersStatus();
      await this.fetchSendersData();
      await this.fetchCustomFieldVariable();
      this.pages = this.$router.options.routes;
      this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
      if (
        this.localModel.optin === 'double' &&
        this.localModel.confirmlink_sendoption === 'email' &&
        this.localModel.confirm_email_id
      ) {
        this.emailTemplateId = this.localModel.confirm_email_id;
        this.templateType = 'user-email';
      }
      
      this.hideLoader();
    } catch (error) {
      this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
    }
  },

  validations: {
    localModel: {
      confirmlink_subject: {
        required,
      },
      confirmlink_pageurl: {
        url,
        // required,
      },
      success_pageurl: {
        url,
        required,
      },
    },
  },

  methods: {
    ...mapGetters('mailing', ['getCanMail']),

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    handleImageInsertionInContent() {
      this.$refs['optin-form-email-editor'].handleImageInsertionInContent(); 
    },

    checkValidEmailContent() {
      let validEmailContent = false;
      if (this.isEmailContentSubmitted) {
        if (this.localModel.confirm_editor_type === 1 || this.localModel.confirm_editor_type === 2) {
          if (this.localModel.confirmlink_content && this.localModel.confirmlink_content.includes('{optin_confirmation_link}')) {
            validEmailContent = true;
          }
        } else if (
          this.localModel.confirmlink_content.includes('{optin_confirmation_link}') &&
          (
            this.localModel.confirmlink_content ||
            this.localModel.confirm_email_sections
          )
        ) {
          validEmailContent = true;
        }
      } else {
        validEmailContent = true;
      }
      return !validEmailContent;
    },

    validateEmailContent() {
      const editor = this.$refs ? this.$refs['optin-form-email-editor'] : null;
      syncEditorContent(editor, (html) => {
        this.localModel.confirmlink_content = html;
      });
    },

    // open confirmEmailChangeLost modal
    openConfirmEmailChangeLost(option) {
      // set the confirmTarget
      this.confirmTarget = option;

      if (option === 'email') {
        // set the confirmMessage and confirmTarget
        this.confirmMessage = this.$t('frontend_groovemail_email_builder_content_will_be_lost');

        // check change in content of email builder
        const changeInContent = this.$refs['optin-form-email-builder'].checkChangeInContent();
        if (changeInContent) {
          // open confirmation email chnage lost modal
          this.$refs[`step2-confirmation-email-change-lost`].open();
        } else {
          this.closeBefreeBuilderSlider();
        }
        this.confirm_template_id = null;
      } else if (option === 'template') {
        this.confirmMessage = this.$t('frontend_groovemail_befree_email_builder_change_template_warning');

        // open confirmation chnage tamplate lost data modal
        this.$refs[`step2-confirmation-email-change-lost`].open();
      }
    },


    // confirm email chnage lost modal
    confirmEmailChangeLost() {
      if(this.confirmTarget === 'email') {
        this.closeBefreeBuilderSlider();
      } else if (this.confirmTarget === 'template') {
        this.closeBefreeBuilderSlider();
        this.initializeEmailContentData();
        this.$emit('fetchTemplates', 1);
      }

      // reset the confirmMessage and confirmTarget
      this.confirmTarget = '';
      this.confirmMessage = '';
    },

     // open confirmation editor type
     openConfirmationEditorType(newEmailType, oldEmailType) {
      // set new and old email type
      this.newEmailType = newEmailType;
      this.oldEmailType = oldEmailType;

      // open confirmation editor type
      this.$refs[`step2-confirmation-editor-type`].open();
    },

    // confirm editor type chnage
    confirmEditorTypeChange() {
      this.initializeEmailContentData();
      if ((this.newEmailType === 1 || this.newEmailType === 2)) {
        this.$emit('saveOnEmailContentReset');
      }

      this.showEmailComposers = true;

      // reset new and old email type
      this.newEmailType = null;
      this.oldEmailType = null;
    },

    // close confirmation editor type
    closeConfirmEditorTypeChange() {
      // reset new and old email type
      this.localModel.confirm_editor_type = this.oldEmailType;
          this.editorTypeChangedInternally = true;

      this.showEmailComposers = true;


      // reset new and old email type
      this.newEmailType = null;
      this.oldEmailType = null;
    },

    openBefreeBuilderSlider() {
      this.$root.$emit('expand-slider', 'generic-email-builder-modal-confirm');
    },

    closeBefreeBuilderSlider() {
      this.$root.$emit('collapse-slider', 'generic-email-builder-modal-confirm');
    },

    async openConfirmPreview() {
      this.$emit(
        'openConfirmPreview',
        {
          previewContent: this.localModel.confirmlink_content,
          contentType: this.localModel.confirmlink_sendoption,
        },
        false,
        (this.localModel.confirm_editor_type === 3 || this.localModel.confirm_email_id)
      );
    },

    openEmailBuilder() {
      if (this.localModel.confirm_email_id || this.localModel.confirmlink_content) {
        this.openBefreeBuilderSlider();
      } else {
        this.$emit('fetchTemplates', 1);
      }
    },

    assignTemplateDataInBuilder(templateId, templateType) {
      if (templateId) {
        this.emailTemplateId = templateId;
      }
      this.templateType = templateType || 'template';
      this.openBefreeBuilderSlider();
    },

    saveContentWithMeta(saveAs, emailJson, htmlData, emailTemplateMeta) {
      if (saveAs === 1 || saveAs === 3) {
        this.saveEmailContent(emailJson, htmlData, emailTemplateMeta, saveAs);
      } else if (saveAs === 2) {
        this.saveTemplateContent(emailJson, htmlData, emailTemplateMeta);
      }
    },

    async saveEmailContent(emailJson, htmlData, emailTemplateMeta, saveAs) {
      this.localModel.confirmlink_content = htmlData;
      this.localModel.confirm_email_sections = emailJson;
      if (emailTemplateMeta) {
        this.localModel.confirm_template_name = emailTemplateMeta.templateName;
        this.localModel.confirm_template_folder = emailTemplateMeta.templateFolder;
      }
      if (this.localModel.confirm_email_id) {
        try {
          this.showLoader();
          const emailPayload = this.fetchEmailPayload(emailJson, htmlData, emailTemplateMeta);
          await axios.put(
            `/email/template/${this.localModel.confirm_email_id}`, emailPayload
          );
          if (saveAs === 3) {
            this.closeBefreeBuilderSlider();
            this.confirm_template_id = null;
          }
          this.hideLoader();
        } catch (error) {
          this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
        }
      } else {
        try {
          this.showLoader();
          const emailPayload = this.fetchEmailPayload(emailJson, htmlData, emailTemplateMeta);
          const emailSaveRes = await axios.post(
            `/email/template/create`, emailPayload
          );
          this.localModel.confirm_email_id = emailSaveRes?.data?.id ? emailSaveRes?.data?.id : null;
          this.emailTemplateId = this.localModel.confirm_email_id;
          this.templateType = 'user-email';
          if (saveAs === 3) {
            this.closeBefreeBuilderSlider();
            this.confirm_template_id = null;
          }
          this.hideLoader();
        } catch (error) {
          this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
        }
      }
    },
    
    fetchEmailPayload(jsonData, htmlData, templateMeta) {
      return {
        message: htmlData,
        template_name: templateMeta.templateName,
        category_id: templateMeta.templateFolder,
        emailContentSections: jsonData,
        screenshot_image: templateMeta.screenshot ? templateMeta.screenshot : '',
      };
    },

    async saveTemplateContent(emailJson, htmlData, emailTemplateMeta) {
      if (emailTemplateMeta.templateId) {
        await this.updateTemplateContent(emailJson, htmlData, emailTemplateMeta);
      } else {
        await this.saveNewTemplateContent(emailJson, htmlData, emailTemplateMeta);
      }
    },

    fetchTemplatePayload(jsonData, htmlData, templateMeta) {
      return {
        template_name: templateMeta.templateName,
        category_id: templateMeta.templateFolder,
        emailContentSections: jsonData,
        message: htmlData,
        screenshot_image: templateMeta.screenshot ? templateMeta.screenshot : '',
      };
    },

    async saveNewTemplateContent(jsonData, htmlData, templateMeta) {
      try {
        this.showLoader();
        const templatePayload = this.fetchTemplatePayload(jsonData, htmlData, templateMeta);
        const templateSaveRes = await axios.post(
          `/user/template/create`, templatePayload
        );
        this.confirm_template_id = templateSaveRes?.data?.id ? templateSaveRes?.data?.id : null;
        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    async updateTemplateContent(jsonData, htmlData, templateMeta) {
      try {
        this.showLoader();
        const templatePayload = this.fetchTemplatePayload(jsonData, htmlData, templateMeta);
        const templateSaveRes = await axios.put(
          `/user/template/${this.confirm_template_id}`, templatePayload
        );
        this.confirm_template_id = templateSaveRes?.data?.id ? templateSaveRes?.data?.id : null;
        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },

    initializeEmailContentData() {
      this.localModel.confirmlink_content = '';
      this.localModel.confirm_email_sections = '';
      this.localModel.confirm_email_id = null;
      this.localModel.confirm_template_name = '';
      this.localModel.confirm_template_folder = null;
    },

    isSuccessUrlInvalid() {
      return this.$v.localModel.success_pageurl.$invalid;
    },

    closeSmsVariables() {
      this.showSmsVariableDropdown = false;
    },

    openSmsVariables() {
      this.showSmsVariableDropdown = true;
    },

    
    closeSubjectVariables() {
      this.showSubjectDropdown = false;
    },
    
    openSubjectVariables() {
      this.showSubjectDropdown = true;
    },


    searchQueryChangedSmsVariable(searchQuery) {
      if (searchQuery) {
        this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject.filter(
          (ele) => ele.label.toLowerCase().includes(searchQuery.toLowerCase())
        );
      } else {
        this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
      }
    },

    updateConfirmationEmailSender(data) {
      if (data && data === 'createSenderOption1') {
        this.localModel.confirmlink_sender_id = null;
        this.openCreateEmailSenderModal();
      }
    },

    updateConfirmationSmsSender(data) {
      if (data && data === 'createSenderOption1') {
        this.localModel.confirmlink_sender_id = null;
        this.openCreateSmsSenderModal();
      }
    },

    async emailSenderCreated(senderData, setSender) {
      if (this.verifiedSendersRequired) {
        const { data } = await axios.get('/sender', {
          params: { verify: 1 },
        });
        if (data.length > 0) {
          this.senders = data;
        }
      } else {
        const { data } = await axios.get('/sender');
        if (data.length > 0) {
          this.senders = data;
        }
      }
      if (!this.verifiedSendersRequired && setSender && senderData && senderData.id) {
        this.localModel.confirmlink_sender_id = senderData.id;
      }
    },

    openCreateEmailSenderModal() {
      this.$emit('openCreateEmailSenderModal', { type: 1 });
    },

    async smsSenderCreated(senderData, setSender) {
      const fetchedSenders = await axios.get('/sms-sender');
      this.smsSenders = fetchedSenders.data;
      if (setSender && senderData && senderData.id) {
        this.localModel.confirmlink_sender_id = senderData.id;
      }
    },

    openCreateSmsSenderModal() {
      this.$emit('openCreateSmsSenderModal', { type: 1 });
    },

    async fetchCustomFieldVariable() {
      try {
        const customFieldsData = await axios.post('/customfield-variables');
        customFieldsData.data.forEach(fieldData => {
          this.dynamic_variables_sms_subject.push(fieldData);
          const mergeTagData = fieldData;
          mergeTagData.name = mergeTagData.label;
          this.builderVariables.push(mergeTagData);
        });
      } catch (e) {
        console.log(e);
      }
    },

    async checkPhonePresent() {
      if (
        this.localModel &&
        this.localModel.form_fields &&
        this.localModel.form_fields.length
      ) {
        this.localModel.form_fields.forEach((ele) => {
          if (ele.name === 'phone_number') {
            this.formConatinsPhone = true;
          }
        });
      }
      let smsOption;
      if (this.confirm_options && this.confirm_options.length) {
        smsOption = this.confirm_options.findIndex((ele) => {
          return ele.id === 'sms';
        });
      }
      if (this.formConatinsPhone) {
        this.confirm_options[smsOption].sms_not_allowed = false;
      } else {
        this.confirm_options[smsOption].sms_not_allowed = true;
      }
    },

    async confirmationOptinUpdated() {
      this.resetConfirmationTemplateSettings();
      await this.fetchSendersData();
    },

    async confirmationSendOptionUpdated() {
      this.localModel.confirmlink_sender_id = null;
      this.resetConfirmationTemplateSettings();
      await this.fetchSendersData();
    },

    resetConfirmationTemplateSettings() {
      this.localModel.confirm_editor_type = 1;
      this.localModel.confirm_email_id = null;
      this.localModel.confirm_template_name = '';
      this.localModel.confirm_template_folder = null;
    },

    // Set the variable in the content for the SMS
    copySmsvariable(option) {
      // target element to insert variable
      const content = document.getElementById('sms-text-area');

      let position;

      if (content && content.selectionStart != null && content.selectionStart !== undefined) {
        position = content.selectionStart;
      } else {
        return false;
      }

      this.localModel.confirmlink_sms_content = [
        this.localModel.confirmlink_sms_content.slice(0, position),
        option.value,
        this.localModel.confirmlink_sms_content.slice(position),
      ].join('');

      content.focus();

      content.setSelectionRange(
        position + option.value.length,
        position + option.value.length
      );
      this.showSmsVariableDropdown = false;
      this.smsVariableSearch = '';
      this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
    },

    async fetchSendersStatus() {
      const sendersData = await axios.get('/email-sms-sender');
      if (sendersData.data.admin_setting) {
        this.verifiedSendersRequired = true;
      } else {
        this.verifiedSendersRequired = false;
      }
    },

    async fetchSendersData() {
      if (
        this.localModel.optin === 'double' &&
        this.localModel.confirmlink_sendoption === 'email'
      ) {
        await this.fetchsenders();
      } else if (
        this.localModel.optin === 'double' &&
        this.localModel.confirmlink_sendoption === 'sms'
      ) {
        await this.fetchSmsSenders();
      } else {
        this.localModel.confirmlink_sender_id = null;
      }
    },


    // Sets the default sender ID if the current sender ID is invalid
    setDefaultSenderIdIfInvalid(senderTarget) {
      if (
        (this.$route.name === 'NewForm' &&
          (!this.localModel.confirmlink_sender_id ||
            this.localModel.confirmlink_sender_id === '-1')) ||
        (this.$route.name === 'EditForm' &&
          (!this.localModel.confirmlink_sender_id ||
            this.localModel.confirmlink_sender_id === '-1'))
      ) {
        for (let i = 0; i < senderTarget.length; i += 1) {
          if (senderTarget[i].is_default === 1) {
            this.localModel.confirmlink_sender_id = senderTarget[i].id;
          }
        }
      }
      
      // Sets the sender ID to null if the current sender ID is invalid
      if (this.localModel.sender_id) {
        const sender = senderTarget.find((ele) => {
          return ele.id === this.localModel.sender_id;
        });
        if (!sender) {
          this.localModel.sender_id = null;
        }
      }
    },

    // Fetches SMS sender data from the '/sms-sender' endpoint using an HTTP GET request.
     async fetchSmsSenders() {
      const integerationData = await axios.get('/sms-sender');

      // If the response contains data, sets the 'smsSenders' property to the data.
      if (
        integerationData &&
        integerationData.data &&
        integerationData.data.length
      ) {
        this.smsSenders = integerationData.data;
      }

      // Sets the default sender ID if the current sender ID is invalid
      this.setDefaultSenderIdIfInvalid(this.smsSenders);
    },

    // Fetches email sender data from the '/sender' endpoint using an HTTP GET request.
    async fetchsenders() {
      if (this.verifiedSendersRequired) {
        const { data } = await axios.get('/sender', {
          params: { verify: 1 },
        });
        if (data.length > 0) {
          this.senders = data;
        }
      } else {
        const { data } = await axios.get('/sender');
        if (data.length > 0) {
          this.senders = data;
        }
      }
      
      // Sets the default sender ID if the current sender ID is invalid
      this.setDefaultSenderIdIfInvalid(this.senders);
    },


    // Validate email content
    validateEmailUrl() {
      return (
        !this.$v.$invalid &&
        this.localModel.confirmlink_content &&
        this.localModel.confirmlink_content.includes('{optin_confirmation_link}') &&
        this.localModel.confirmlink_sender_id &&
        this.localModel.confirmlink_sender_id !== '-1' &&
        (
          (this.localModel.confirm_editor_type === 1 || this.localModel.confirm_editor_type === 2 ) ||
          this.localModel.confirm_email_sections
        )
      );
    },

    // Validate email subject and content
    validateEmailSubjectAndContent() {
      return (
        this.localModel.confirmlink_subject &&
        !this.$v.localModel.confirmlink_pageurl.$invalid &&
        this.localModel.confirmlink_content &&
        this.localModel.confirmlink_content.includes('{optin_confirmation_link}') &&
        this.localModel.confirmlink_sender_id &&
        this.localModel.confirmlink_sender_id !== '-1' &&
        (
          (this.localModel.confirm_editor_type === 1 || this.localModel.confirm_editor_type === 2) ||
          this.localModel.confirm_email_sections
        )
      );
    },

    validateSmsUrl() {
      // Validate SMS content
      return (
        !this.$v.localModel.success_pageurl.$invalid &&
        !this.$v.localModel.confirmlink_pageurl.$invalid &&
        this.localModel.confirmlink_sms_content &&
        this.localModel.confirmlink_sms_content.includes('{optin_confirmation_link}') &&
        this.localModel.confirmlink_sender_id &&
        this.localModel.confirmlink_sender_id !== '-1'
      );
    },


    // Validate SMS content
    validateSmsSubjectAndContent() {
      return (
        !this.$v.localModel.confirmlink_pageurl.$invalid &&
        this.localModel.confirmlink_sms_content &&
        this.localModel.confirmlink_sms_content.includes('{optin_confirmation_link}') &&
        this.localModel.confirmlink_sender_id &&
        this.localModel.confirmlink_sender_id !== '-1'
      );
    },

    validateBeforeSubmit() {
      // Check if optin is not double
      if (this.localModel.optin !== 'double') {
        // Check if success_option is url
        return this.localModel.success_option === 'url' ? !this.$v.localModel.success_pageurl.$invalid : true;
      }

      // Check if confirmlink_sendoption is email
      if (this.localModel.confirmlink_sendoption === 'email') {
        // Check if success_option is url
        return this.localModel.success_option === 'url' ?  this.validateEmailUrl() : this.validateEmailSubjectAndContent();
      } else {
        // Check if success_option is url
        return this.localModel.success_option === 'url' ? this.validateSmsUrl() : this.validateSmsSubjectAndContent();
      }
    },

    validate() {
      if (
        this.localModel.confirmlink_sendoption === 'email' &&
        (this.localModel.confirm_editor_type === 1 || this.localModel.confirm_editor_type === 2)
      ) {
        this.validateEmailContent();
      }
      this.$v.$touch();
      if (this.localModel.confirmlink_sendoption === 'email') {
        this.isEmailContentSubmitted = true;
      } else if (this.localModel.confirmlink_sendoption === 'sms') {
        this.isSmsContentSubmitted = true;
      }
      return this.validateBeforeSubmit();
    },

    setoptinvalue(option) {
      this.selected_optin_value = option.title;
    },

    copyVariableInSubject(option) {
      if (!this.localModel.confirmlink_subject) {
        this.localModel.confirmlink_subject = '';
      }
      this.localModel.confirmlink_subject += `${option.value}`;
      this.showSubjectDropdown = false;
      this.emailSubjectVariableSearch = '';
      this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
    },

    async proceeedSendingTestEmail() {
      if (
        this.localModel.optin === 'double' &&
        this.localModel.confirmlink_sendoption === 'email' &&
        this.localModel.confirmlink_sender_id &&
        this.localModel.confirmlink_sender_id !== -1 &&
        this.localModel.confirmlink_content &&
        !this.$v.localModel.confirmlink_subject.$invalid
      ) {
        await this.$refs.sendConfirmationTestMail.sendTestEmail(
          this.localModel.confirmlink_sender_id,
          this.localModel.confirmlink_subject,
          this.localModel.confirmlink_previewtext,
          this.localModel.confirmlink_content
        );
      } else if (!this.localModel.confirmlink_sender_id || this.localModel.confirmlink_sender_id === -1) {
        this.requestErrorAlert(this.$t('frontend_groovemail_send_test_email_sender_id_error'));
      } else if (this.$v.localModel.confirmlink_subject.$invalid) {
        this.requestErrorAlert(this.$t('frontend_groovemail_send_test_email_subject_error'));
      } else if (!this.localModel.confirmlink_content) {
        this.requestErrorAlert(this.$t('frontend_groovemail_send_test_email_content_error'));
      } else {
        this.requestErrorAlert(this.$t('frontend_error'));
      }
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },
  },

  computed: {
    builderVariables() {
      return [
        {
          name: this.$t('frontend_groovemail_contacts_step2_first_name'),
          label: this.$t('frontend_groovemail_contacts_step2_first_name'),
          value: '{first_name}',
        },
        {
          name: this.$t('frontend_groovemail_contacts_step2_last_name'),
          label: this.$t('frontend_groovemail_contacts_step2_last_name'),
          value: '{last_name}',
        },
        {
          name: this.$t('frontend_groovemail_email_show_email'),
          label: this.$t('frontend_groovemail_email_show_email'),
          value: '{email}',
        },
        {
          name: this.$t('frontend_groovemail_email_show_phone'),
          label: this.$t('frontend_groovemail_email_show_phone'),
          value: '{phone_number}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_company'),
          label: this.$t('frontend_groovemail_mail_lead_index_company'),
          value: '{company}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          label: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          value: '{address_1}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          label: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          value: '{address_2}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_city'),
          label: this.$t('frontend_groovemail_mail_lead_index_city'),
          value: '{city}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_state'),
          label: this.$t('frontend_groovemail_mail_lead_index_state'),
          value: '{state}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_country'),
          label: this.$t('frontend_groovemail_mail_lead_index_country'),
          value: '{country}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          label: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          value: '{zip}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_url'),
          label: this.$t('frontend_groovemail_mail_lead_index_url'),
          value: '{url}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          label: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          value: '{tax_number}',
        },
        {
          name: this.$t('frontend_groovemail_mail_lead_index_billing'),
          label: this.$t('frontend_groovemail_mail_lead_index_billing'),
          value: '{billing_address}',
        },
        {
          name: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          label: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          value: '{ip_address}',
        },
        {
          name: this.$t(
            'frontend_groovemail_forms_step2_optin_confirmation_link'
          ),
          label: this.$t(
            'frontend_groovemail_forms_step2_optin_confirmation_link'
          ),
          value: '{optin_confirmation_link}',
        },
      ];
    },

    dynamic_variables_sms_subject() {
      return [
        {
          label: this.$t('frontend_groovemail_contacts_step2_first_name'),
          value: '{first_name}',
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_last_name'),
          value: '{last_name}',
        },
        {
          label: this.$t('frontend_groovemail_email_show_email'),
          value: '{email}',
        },
        {
          label: this.$t('frontend_groovemail_email_show_phone'),
          value: '{phone_number}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_company'),
          value: '{company}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          value: '{address_1}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          value: '{address_2}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_city'),
          value: '{city}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_state'),
          value: '{state}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_country'),
          value: '{country}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          value: '{zip}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_url'),
          value: '{url}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          value: '{tax_number}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_billing'),
          value: '{billing_address}',
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          value: '{ip_address}',
        },
        {
          label: this.$t(
            'frontend_groovemail_forms_step2_optin_confirmation_link'
          ),
          value: '{optin_confirmation_link}',
        },
      ];
    },
    
    email_type_options() {
      return [
        {
          id: 3,
          title: this.$t(
            'frontend_groovemail_email_type_email_builder_text'
          ),
          description: this.$t(
            'frontend_groovemail_email_type_email_builder_description'
          ),
          placeholder: '',
        },
        {
          id: 1,
          title: this.$t(
            'frontend_groovemail_email_type_basic_editor_text'
          ),
          description: this.$t(
            'frontend_groovemail_email_type_basic_editor_description'
          ),
          placeholder: '',
        },
        {
          id: 2,
          title: this.$t(
            'frontend_groovemail_email_type_html_paste_text'
          ),
          description: this.$t(
            'frontend_groovemail_email_type_html_paste_description'
          ),
          placeholder: '',
        },
      ];
    },

    confirmationEmailSenderList() {
      const senderList = [];
      if (this.senders && this.senders.length) {
        this.senders.forEach((element) => {
          senderList.push({ value: element.id, text: element.name });
        });
      }

      return senderList;
    },

    confirmationSmsSenderList() {
      const senderList = [];
      if (this.smsSenders && this.smsSenders.length) {
        this.smsSenders.forEach((element) => {
          senderList.push({ value: element.id, text: element.gateway_name });
        });
      }
      
      return senderList;
    },

    optin_radio_options() {
      return [
        {
          id: 'single',
          title: this.$t('frontend_groovemail_forms_step2_single_optin'),
          description: this.$t('frontend_groovemail_forms_step2_yours_leads'),
        },
        // Groovemail Rollback (coming soon added)
        {
          id: 'double',
          coming_soon: this.userCanMail === 0,
          title: this.$t('frontend_groovemail_forms_step2_double_optin'),
          description: this.$t(
            'frontend_groovemail_forms_step2_yours_leads_have'
          ),
        },
        // Groovemail Rollback (coming soon added)
      ];
    },

    form_success_options() {
      return [
        {
          id: 'url',
          title: this.$t('frontend_groovemail_forms_step2_success_url_title'),
          description: this.$t(
            'frontend_groovemail_forms_step2_success_url_desc'
          ),
        },
        // {
        //   id: 'message',
        //   title: this.$t(
        //     'frontend_groovemail_forms_step2_success_message_title'
        //   ),
        //   description: this.$t(
        //     'frontend_groovemail_forms_step2_success_message_desc'
        //   ),
        // },
      ];
    },

    confirm_options() {
      return [
        {
          id: 'email',
          title: this.$t('frontend_groovemail_forms_step2_send_by_mail'),
        },
        {
          id: 'sms',
          title: this.$t('frontend_groovemail_forms_step2_send_by_sms'),
          sms_not_allowed: false,
        },
      ];
    },

    //  Can mail/Upgraded user/Sandbox mode check
    userCanMail() {
      return this.getCanMail();
    },
    //  Can mail/Upgraded user/Sandbox mode check

    getEmailMetaData() {
      return {
        emailId: this.localModel.confirm_email_id,
        templateName: this.localModel.confirm_template_name,
        templateFolder: this.localModel.confirm_template_folder,
      };
    },
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },

    'localModel.confirmlink_sendoption': function updateEmailContentData() {
      this.localModel.confirmlink_content = '';
      this.localModel.confirm_email_sections = '';
      if (this.localModel.confirmlink_sendoption === 'email') {
        this.localModel.confirmlink_sms_content = '';
      } else if (this.localModel.confirmlink_sendoption === 'sms') {
        this.localModel.confirmlink_subject = '';
        const phoneNumberField = this.localModel.form_fields.find((ele) => ele.name === 'phone_number');
        if (!phoneNumberField.mandatory) {
          Notify.warn(
            this.$t('frontend_groovemail_forms_phone_number_field_mandatory_warning_message')
          );
        }
      }
    },

    'localModel.confirm_editor_type': async function handleEmailTypeChange(newEmailType, oldEmailType) {
      if (this.editorTypeChangedInternally) {
        this.editorTypeChangedInternally = false;
      } else if (
        (((newEmailType === 1 || newEmailType === 2) && oldEmailType === 3) ||
        newEmailType === 3) && this.localModel.confirmlink_content
      ) {
        this.showEmailComposers = false;
        
        // open confirmation editor type
        this.openConfirmationEditorType(newEmailType, oldEmailType);
      } else if (newEmailType === 2 && oldEmailType === 1) {
        this.validateEmailContent();
      }
    },

    'localModel.success_option': function resetSuccessPageUrl() {
      if (this.localModel.success_option === 'message') {
        this.localModel.success_pageurl = '';
      }
    },  
  },
};
</script>

<style lang="scss">
.variables {
  overflow: auto;
  min-height: 340px;
  direction: rtl;
  
  .field {
    cursor: pointer;
  }
}

.ck-editor__editable {
  min-height: 350px;
}

.text-uppercase {
  text-transform: uppercase;
}


.custom-radio-list {
  & > .rounded {
    padding: 0;
    margin: 0;
    border: none;
    .w-6 {
      height: 23px;
      margin: 0;
    }
    label.flex {
      margin-bottom: 16px;
    }
    label.font-semibold {
      font-size: 14px;
      font-weight: normal;
      color: #191d3a;
    }
  }
}

.tooltip {
  &.info {
    .tooltip-inner {
      background: #fff;
      color: #191d3a;
      padding: 12px 16px;
      border-radius: 6px;
      box-shadow: 0 0 10px #d5d8e5;
      max-width: 250px;
    }

    .tooltip-arrow {
      border-color: #fff;
    }
  }
}

#success-message .form-setup-radio .w-6 {
  display: none;
}
</style>
